(() => {
  const CONFIG = {
    minQuantity: 2,
    giftHandle: 'organik-aloe-vera-jel-200-ml',
    autoTag: '_auto_gift_gunes_bakim',
    collectionHandle: 'organik-gunes-bakim'
  };

  const CAMPAIGN = {
    startDate: { year: 2026, month: 5, day: 12 },
    endDate:   { year: 2026, month: 5, day: 31 }
  };

  let isProcessing = false;
  let pendingCheck = false;
  let collectionProductIds = null;
  let cachedGiftId = null;

  function isCampaignActive() {
    const now = new Date();
    const trTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
    const toNum = (y, m, d) => y * 10000 + m * 100 + d;
    const nowNum = toNum(trTime.getFullYear(), trTime.getMonth() + 1, trTime.getDate());
    const startNum = toNum(CAMPAIGN.startDate.year, CAMPAIGN.startDate.month, CAMPAIGN.startDate.day);
    const endNum = toNum(CAMPAIGN.endDate.year, CAMPAIGN.endDate.month, CAMPAIGN.endDate.day);
    return nowNum >= startNum && nowNum <= endNum;
  }

  async function getCollectionProductIds() {
    if (collectionProductIds) return collectionProductIds;
    try {
      const ids = [];
      let page = 1;
      let hasMore = true;
      while (hasMore) {
        const res = await fetch(`/collections/${CONFIG.collectionHandle}/products.json?limit=250&page=${page}`);
        if (!res.ok) return null;
        const data = await res.json();
        if (data.products && data.products.length > 0) {
          data.products.forEach(p => ids.push(Number(p.id)));
          page++;
          if (data.products.length < 250) hasMore = false;
        } else {
          hasMore = false;
        }
      }
      collectionProductIds = new Set(ids);
      return collectionProductIds;
    } catch (e) {
      return null;
    }
  }

  async function getGiftId() {
    if (cachedGiftId) return cachedGiftId;
    try {
      const res = await fetch(`/products/${CONFIG.giftHandle}.js`);
      if (!res.ok) return null;
      const data = await res.json();
      cachedGiftId = data.variants?.[0]?.id || null;
      return cachedGiftId;
    } catch (e) { return null; }
  }

  // Sayfa yüklendiğinde verileri önceden çek
  function preloadData() {
    getGiftId();
    getCollectionProductIds();
  }

  async function forceUpdateCartUI() {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      const sectionsToRender = cartDrawer.getSectionsToRender().map(s => s.id);
      const res = await fetch(`/?sections=${sectionsToRender.join(',')}`);
      if (!res.ok) return;
      const sections = await res.json();
      cartDrawer.renderContents({ sections });

      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        const details = cartDrawer.querySelector('details');
        if (details) details.setAttribute('open', '');
      }
    } catch (err) {
      console.error('[Kampanya] UI güncelleme hatası:', err);
    }
  }

  async function removeGiftIfExists(giftId) {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const freeItem = cart.items.find(
      i => i.variant_id === giftId && i.properties?.[CONFIG.autoTag] === 'true'
    );
    if (freeItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: freeItem.key, quantity: 0 })
      });
      await forceUpdateCartUI();
    }
  }

  async function checkRules() {
    if (isProcessing) {
      pendingCheck = true;
      return;
    }
    isProcessing = true;
    pendingCheck = false;

    try {
      // Gift ID, koleksiyon ve sepet verisini paralel çek
      const [giftId, validIds, cartRes] = await Promise.all([
        getGiftId(),
        getCollectionProductIds(),
        fetch('/cart.js')
      ]);

      if (!giftId) return;

      if (!isCampaignActive()) {
        await removeGiftIfExists(giftId);
        return;
      }

      if (!validIds) return;

      const cart = await cartRes.json();

      const freeItem = cart.items.find(
        i => i.variant_id === giftId && i.properties?.[CONFIG.autoTag] === 'true'
      );
      const paidItem = cart.items.find(
        i => i.variant_id === giftId && (!i.properties || i.properties[CONFIG.autoTag] !== 'true')
      );

      let collectionQuantity = 0;
      cart.items.forEach(i => {
        const isAutoGift = i.variant_id === giftId && i.properties?.[CONFIG.autoTag] === 'true';
        if (!isAutoGift && validIds.has(Number(i.product_id))) {
          collectionQuantity += i.quantity;
        }
      });

      const shouldAddGift = collectionQuantity >= CONFIG.minQuantity;

      let actionNeeded = false;

      if (shouldAddGift) {
        if (freeItem) {
          if (freeItem.quantity > 1) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: freeItem.key, quantity: 1 })
            });
            actionNeeded = true;
          }
        } else {
          if (paidItem) {
            if (paidItem.quantity === 1) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: paidItem.key, properties: { [CONFIG.autoTag]: 'true' } })
              });
            } else {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: paidItem.key, quantity: paidItem.quantity - 1 })
              });
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: giftId, quantity: 1, properties: { [CONFIG.autoTag]: 'true' } }]
                })
              });
            }
            actionNeeded = true;
          } else {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: giftId, quantity: 1, properties: { [CONFIG.autoTag]: 'true' } }]
              })
            });
            actionNeeded = true;
          }
        }
      } else {
        if (freeItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: freeItem.key, quantity: 0 })
          });
          actionNeeded = true;
        }
      }

      if (actionNeeded) await forceUpdateCartUI();

    } catch (err) {
      console.error('[Kampanya Hatası]', err);
    } finally {
      isProcessing = false;
      if (pendingCheck) {
        setTimeout(checkRules, 50);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      preloadData();
      setTimeout(checkRules, 100);
    });
  } else {
    preloadData();
    setTimeout(checkRules, 50);
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = args[0] && (typeof args[0] === 'string' ? args[0] : args[0]?.url);
    const isCartMutation = url && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    );

    const response = await originalFetch.apply(this, args);

    if (isCartMutation && !isProcessing) {
      setTimeout(checkRules, 50);
    }

    return response;
  };
})();